import { z } from 'zod';
import { paginationQuerySchema } from './common.js';
/**
 * Requêtes de consultation du référentiel employeurs/travailleurs (lecture
 * seule — voir apps/api/src/modules/referentiel/sync-provider.ts et
 * docs/cutover-cnss-sync.md). La recherche employeur porte sur la dénomination
 * sociale ou le numéro d'affiliation ; la recherche travailleur sur le nom/
 * postnom/prénom ou le numéro d'immatriculation.
 */
export const listEmployeursQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(160).optional(),
});
export const listTravailleursQuerySchema = paginationQuerySchema.extend({
    search: z.string().max(160).optional(),
    employeurId: z.coerce.number().int().positive().optional(),
});
//# sourceMappingURL=referentiel.js.map